import { apiProxyRequest } from "Api/apiProxyRequest";

import type { OrganizationAddon } from "Reducers/organization/addons";

export const getAddonsRequest = (organizationId: string) =>
  apiProxyRequest<OrganizationAddon>(`/organizations/${organizationId}/addons`);
